<script lang="ts">
	import { link } from "svelte-routing";
	import { pick } from "svelte-routing/src/utils";
	import { globalHistory } from "svelte-routing/src/history";
	import SideIcons from "./SideIcons.svelte";
	import { t } from "../stores";
	import { allStoreMode } from "../v7/store";

	export let linkClickAfterHanlder = () => {};

	let path = window.location.pathname;
	globalHistory.listen((v) => (path = v.location.pathname));

	$: sidenavItems = [
		{
			iconType: "Dashboard",
			label: $t("hub.dashboard.title"),
			route: "/",
			to: "/",
			allStoreModeAllow: true,
		},
		{
			iconType: "Revenue",
			label: $t("hub.revenue.title"),
			route: "/revenue/*",
			to: "/revenue/saleshistory",
			allStoreModeAllow: false,
		},
		{
			iconType: "Store",
			label: $t("hub.store.title"),
			route: "/store/*",
			to: "/store",
			allStoreModeAllow: false,
		},
		{
			iconType: "Product",
			label: $t("hub.product.title"),
			route: "/product/*",
			to: "/product/item",
			allStoreModeAllow: false,
		},
		{
			iconType: "Point",
			label: $t("hub.point.title"),
			route: "/earning/*",
			to: "/earning/history",
			allStoreModeAllow: false,
		},
		{
			iconType: "Place",
			label: $t("hub.place.title"),
			route: "/place/*",
			to: "/place",
			allStoreModeAllow: false,
		},
	];
	$: routes = sidenavItems?.map((i) => ({ path: i.route })) || [];
	$: matched = pick(routes, path);
	$: filteredSideNavItems = $allStoreMode
		? sidenavItems.filter((v) => v.allStoreModeAllow)
		: sidenavItems;

</script>

<nav class="sidenav-list">
	{#each filteredSideNavItems as item}
		<a href={item.to} use:link on:click={linkClickAfterHanlder}>
			<div class="img-box">
				<SideIcons
					iconType={item.iconType}
					active={matched?.route.path === item.route} />
			</div>
			<span class:active={matched?.route.path === item.route}>
				{item.label}
			</span>
		</a>
	{/each}
</nav>

<style lang="scss">
	@import "../variables.scss";

	.sidenav-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 30px;
		flex-grow: 1;
		padding: 32px 0px 20px 20px;
		box-sizing: border-box;
		overflow-y: auto;
		a {
			display: flex;
			gap: 10px;
			transition: color 0.5s;
			color: var(--lightGrey);

			&:hover {
				color: rgb(223, 223, 223);
			}

			.img-box {
				width: 20px;
				height: 20px;
				position: relative;
			}

			span {
				flex-grow: 1;

				&.active {
					color: white;
					font-weight: 500;
				}
			}
		}
	}

	//Desktop
	@include DesktopSize {
		.sidenav-list {
			gap: 42px;
			padding: 42px 0px 50px 50px;

			a {
				gap: 14px;
				align-items: center;
				font-size: 1.25rem;
				.img-box {
					width: 26px;
					height: 26px;
				}
			}
		}
	}

</style>
